/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { centerLogControllerSearch } from '../fn/center-log/center-log-controller-search';
import { CenterLogControllerSearch$Params } from '../fn/center-log/center-log-controller-search';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CenterLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `centerLogControllerSearch()` */
  static readonly CenterLogControllerSearchPath = '/api/center-log/search';

  /**
   * 센터 로그 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `centerLogControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerLogControllerSearch$Response(params: CenterLogControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return centerLogControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터 로그 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `centerLogControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  centerLogControllerSearch(params: CenterLogControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.centerLogControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

}
